<template>
  <section class="quality-section" id="quality">
    <v-container class="quality-container">
      <!-- Section Title -->
      <h2 class="section-title animate-block">{{ $t('quality.sectionTitle') }}</h2>

      <!-- Quality Items Grid -->
      <div class="quality-grid">
        <div
          v-for="(item, index) in qualityItems"
          :key="index"
          class="animate-block quality-card"
        >
          <!-- Icon -->
          <svg class="quality-icon" width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.5625 18.6875H20.125V8.62496C20.125 8.24371 19.9735 7.87808 19.704 7.60849C19.4344 7.33891 19.0687 7.18746 18.6875 7.18746H12.9375V2.87496C12.9377 2.61465 12.8672 2.35918 12.7335 2.13581C12.5998 1.91245 12.408 1.72958 12.1785 1.60671C11.949 1.48385 11.6904 1.42561 11.4304 1.43821C11.1704 1.4508 10.9187 1.53377 10.7022 1.67824L3.51469 6.46871C3.31752 6.60026 3.15593 6.77852 3.04433 6.98763C2.93272 7.19674 2.87455 7.4302 2.875 7.66722V18.6875H1.4375C1.24688 18.6875 1.06406 18.7632 0.929267 18.898C0.794475 19.0328 0.71875 19.2156 0.71875 19.4062C0.71875 19.5968 0.794475 19.7796 0.929267 19.9144C1.06406 20.0492 1.24688 20.125 1.4375 20.125H21.5625C21.7531 20.125 21.9359 20.0492 22.0707 19.9144C22.2055 19.7796 22.2812 19.5968 22.2812 19.4062C22.2812 19.2156 22.2055 19.0328 22.0707 18.898C21.9359 18.7632 21.7531 18.6875 21.5625 18.6875ZM18.6875 8.62496V18.6875H12.9375V8.62496H18.6875ZM4.3125 7.66722L11.5 2.87496V18.6875H4.3125V7.66722ZM10.0625 10.0625V11.5C10.0625 11.6906 9.98677 11.8734 9.85198 12.0082C9.71719 12.143 9.53437 12.2187 9.34375 12.2187C9.15313 12.2187 8.97031 12.143 8.83552 12.0082C8.70073 11.8734 8.625 11.6906 8.625 11.5V10.0625C8.625 9.87183 8.70073 9.68902 8.83552 9.55422C8.97031 9.41943 9.15313 9.34371 9.34375 9.34371C9.53437 9.34371 9.71719 9.41943 9.85198 9.55422C9.98677 9.68902 10.0625 9.87183 10.0625 10.0625ZM7.1875 10.0625V11.5C7.1875 11.6906 7.11177 11.8734 6.97698 12.0082C6.84219 12.143 6.65937 12.2187 6.46875 12.2187C6.27813 12.2187 6.09531 12.143 5.96052 12.0082C5.82573 11.8734 5.75 11.6906 5.75 11.5V10.0625C5.75 9.87183 5.82573 9.68902 5.96052 9.55422C6.09531 9.41943 6.27813 9.34371 6.46875 9.34371C6.65937 9.34371 6.84219 9.41943 6.97698 9.55422C7.11177 9.68902 7.1875 9.87183 7.1875 10.0625ZM7.1875 15.0937V16.5312C7.1875 16.7218 7.11177 16.9046 6.97698 17.0394C6.84219 17.1742 6.65937 17.25 6.46875 17.25C6.27813 17.25 6.09531 17.1742 5.96052 17.0394C5.82573 16.9046 5.75 16.7218 5.75 16.5312V15.0937C5.75 14.9031 5.82573 14.7203 5.96052 14.5855C6.09531 14.4507 6.27813 14.375 6.46875 14.375C6.65937 14.375 6.84219 14.4507 6.97698 14.5855C7.11177 14.7203 7.1875 14.9031 7.1875 15.0937ZM10.0625 15.0937V16.5312C10.0625 16.7218 9.98677 16.9046 9.85198 17.0394C9.71719 17.1742 9.53437 17.25 9.34375 17.25C9.15313 17.25 8.97031 17.1742 8.83552 17.0394C8.70073 16.9046 8.625 16.7218 8.625 16.5312V15.0937C8.625 14.9031 8.70073 14.7203 8.83552 14.5855C8.97031 14.4507 9.15313 14.375 9.34375 14.375C9.53437 14.375 9.71719 14.4507 9.85198 14.5855C9.98677 14.7203 10.0625 14.9031 10.0625 15.0937Z" fill="#1FB1C1"/>
          </svg>

          <!-- Title -->
          <h3 class="quality-title">{{ item.title }}</h3>

          <!-- Description -->
          <p class="quality-description">{{ item.description }}</p>
        </div>
      </div>
    </v-container>
  </section>
</template>

<script>
import { animateOnScroll } from '@/mixins/animateOnScroll'

export default {
  name: 'QualitySection',
  mixins: [animateOnScroll],
  computed: {
    qualityItems() {
      return this.$tm('quality.items')
    }
  }
}
</script>

<style scoped>
.quality-section {
  scroll-margin-top: 126px;
  background: linear-gradient(180deg, #000 0%, #1e1e1e 100%);
  display: flex;
  justify-content: center;
  padding: 80px 0 100px;
}

.quality-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 50px;
}

.section-title {
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 32px;
  font-weight: 500;
  letter-spacing: -0.01em;
  line-height: 41.6px;
  color: rgb(241, 241, 241);
  margin: 0;
}

/* Grid */
.quality-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(50px, 1fr));
  grid-auto-rows: minmax(0, 1fr);
  gap: 14px;
  width: 100%;
}

/* Card */
.quality-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 25px;
  height: 200px;
}

/* Icon */
.quality-icon {
  width: 23px;
  height: 23px;
  flex-shrink: 0;
}

/* Title */
.quality-title {
  font-family: "SF Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: -0.01em;
  line-height: 24px;
  color: rgb(241, 241, 241);
  margin: 0;
  min-height: 48px;
}

/* Description */
.quality-description {
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: -0.01em;
  line-height: 18px;
  color: rgb(125, 125, 125);
  margin: 0;
}

/* Responsive */
@media (max-width: 960px) {
  .quality-section {
    padding: 60px 0 80px;
  }

  .quality-grid {
    grid-template-columns: repeat(2, minmax(50px, 1fr));
  }

  .quality-card {
    height: auto;
  }
}

@media (max-width: 600px) {
  .quality-section {
    padding: 40px 0 60px;
  }

  .quality-grid {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .quality-container {
    gap: 40px;
  }

  .section-title {
    font-size: 24px;
    line-height: 32px;
  }

  .quality-title {
    font-size: 14px;
    line-height: 20px;
    min-height: auto;
  }

  .quality-description {
    font-size: 12px;
  }

  .quality-card {
    gap: 10px;
  }
}
</style>
